import { useSelectedRootLocationConfiguration } from '@infield/features/app-config/hooks';
import type { ThreeDConfiguration } from '@infield/features/app-config/types';

export const useThreeDModelsConfig = (): ThreeDConfiguration | undefined => {
  const rootLocationConfiguration = useSelectedRootLocationConfiguration();

  return rootLocationConfiguration?.threeDConfiguration;
};
